var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 70,
    viewBox: "0 0 64 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3557 1.78571C29.4672 -0.595233 34.5328 -0.595239 38.6443 1.78571L57.3557 12.6214C61.467 15.0023 64 19.4025 64 24.1644V45.8357C64 50.5975 61.467 54.9976 57.3557 57.3788L38.6443 68.2145C34.5328 70.5951 29.4672 70.5951 25.3557 68.2145L6.6443 57.3788C2.53279 54.9976 0 50.5975 0 45.8357V24.1644C0 19.4025 2.53279 15.0023 6.6443 12.6214L25.3557 1.78571Z",
    fill: "#FFB43A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_1_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2553 45.0341C43.6627 46.835 41.3407 47.7336 39.6818 47.5838C37.4162 47.379 34.9509 46.1771 33.0796 44.8537C30.3288 42.9081 27.7521 39.899 26.2507 36.7055C25.1896 34.4489 24.9515 31.674 26.5297 29.6171C27.1134 28.8568 27.7457 28.451 28.693 28.4037C30.0088 28.3397 30.1931 29.0923 30.645 30.2647C30.9816 31.1415 31.4309 32.0362 31.6818 32.945C32.1515 34.6409 30.5093 34.7113 30.3019 36.0975C30.1739 36.9717 31.2325 38.1441 31.7112 38.7675C32.634 39.9815 33.7641 41.0228 35.0495 41.8432C35.7791 42.3027 36.9541 43.1308 37.7887 42.6739C39.0738 41.9699 38.9535 39.803 40.7494 40.5364C41.6799 40.9152 42.5811 41.4618 43.4694 41.9405C44.8428 42.679 44.7788 43.4444 44.2553 45.0341C43.8636 46.2219 44.647 43.8463 44.2553 45.0341",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5687 43.7928C42.8279 46.0439 39.9254 47.1671 37.8518 46.9799C35.0198 46.7239 31.9382 45.2215 29.599 43.5672C26.1605 41.1353 22.9397 37.3738 21.0629 33.382C19.7365 30.5613 19.4389 27.0926 21.4117 24.5215C22.1413 23.5711 22.9317 23.0639 24.1157 23.0047C25.7605 22.9247 25.9909 23.8655 26.5557 25.331C26.9765 26.427 27.5381 27.5454 27.8517 28.6813C28.4389 30.8013 26.3861 30.8893 26.1269 32.622C25.9669 33.7147 27.2901 35.1803 27.8885 35.9595C29.042 37.477 30.4547 38.7786 32.0614 39.8041C32.9734 40.3785 34.4422 41.4137 35.4854 40.8425C37.0918 39.9625 36.9414 37.2538 39.1862 38.1706C40.3494 38.6442 41.4758 39.3274 42.5863 39.9257C44.3031 40.8489 44.2231 41.8057 43.5687 43.7928C43.0791 45.2775 44.0583 42.308 43.5687 43.7928",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_3",
    x: 9,
    y: 12,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1_3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.7be94b08f647ccd242f2acc6798bbe75.svg";
export { ForwardRef as ReactComponent };